import React from 'react';
import { Helmet } from 'react-helmet';

const SEO = (props) => {
  const { content } = props;

  return (
    <div>
      <Helmet>

        <title></title>
        <meta name="author" content='UOL' />
        <meta name="description" content={content.description} />
        <link rel="canonical" href={content.canonical} />

        <meta property="og:title" content={content.title} />
        <meta property="og:type" content='website' />
        <meta property="og:url" content={content.url} />
        <meta property="og:description" content={content.description} />
        <meta property="og:image" content={content.thumbnail} />
      </Helmet>
    </div>
  );
}

export default SEO;
